import { ExtendedCharacterCount } from './character-count'

export * from './character-count'

export default ExtendedCharacterCount